import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { productPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import './index.scss';

export default function ProductSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
  filterOptions,
}: SingleCommonType) {
  const options = useMemo(() => {
    const list: Array<{ text: any; value: string }> = [];
    (filterOptions?.list || []).forEach((item: any) => {
      const isDlc = !item.is_main_game;
      const itemInfo = {
        text: (
          <span>
            {item.entity_name}
            {isDlc ? <span className="options-tag-item">DLC</span> : null}
          </span>
        ),
        value: item.game_product_id,
      };

      if (isDlc) {
        list.push(itemInfo);
      } else {
        list.unshift(itemInfo);
      }
    });
    return list;
  }, [filterOptions]);

  const {
    selects: productSelects,
    setSelects: setProductSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'game_product_ids',
    options: options.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  const { formatMessage } = useIntl();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'game_product_ids',
      commonBackInfo(
        { game_product_ids: isAll ? [] : productSelects },
        { [defaultKey]: text },
        { needChangeEntity: false, isAll },
      ),
    );
  }, [productSelects, formatMessage]);

  return (
    <div className={`product-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={productPlaceholder[lang]}
        onClear={() => setProductSelects([])}
        selectOptionsInfo={[productSelects, setProductSelects]}
        options={options}
        pointKey={FilterButtonPoint.product}
        boxClassName="dbo-product-select-box"
      ></CustomSelect>
    </div>
  );
}
